/**************************************************************
 * Generated by RxDjango on 2026-05-14 19:30 (UTC)            *
 *                                                            *
 * Based on all ContextChannel subclasses in counter.channels *
 *                                                            *
 *                    DO NOT EDIT THIS FILE                   *
 *                                                            *
 * To rebuild it, run:                                        *
 *                                                            *
 *     ./manage.py makefrontend [counter]                     *
 *                                                            *
 **************************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class CounterChannel extends ContextChannel {

  protected endpoint: string = "/ws/counter/";
  protected baseURL: string = SOCKET_URL;

  counter: number = 0;

  increment = async () => {
    return await this.rx.callAction('increment', []);
  };
}
